export enum LogMessages {
  Deleting_report = 'Report deleted',
  Uploading_deliverable_report = 'File uploaded',
  Cloning_a_deliverable = 'Deliverable cloned',
  Emailing_a_deliverable = 'Reports emailed to',
}
